import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Slider from "react-slick";
import Link from "@mui/material/Link";
import { getChooseSimForm } from "../../../features/middleware/chooseMiddleware";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../hooks/usedTypedSelector";
import { backGroundColorMultiples } from "../../../support/multipleclr";

const ChooseSimform = () => {
  // prev & next button custom for react slick plugin

  const PreviousBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#3D3D3D"
            fillRule="evenodd"
            d="M0 12a1.22 1.22 0 0 1 0-.13v-.11a1.25 1.25 0 0 1 0-.13l.05-.1.07-.12.07-.09.08-.1L11 .39a1.3 1.3 0 0 1 1.82 0 1.25 1.25 0 0 1 0 1.79l-8.43 8.56h26.32a1.3 1.3 0 0 1 0 2.59H4.29l8.55 8.55a1.25 1.25 0 0 1 0 1.79 1.3 1.3 0 0 1-1.82 0L.37 13l-.08-.09-.08-.09-.06-.11-.06-.11a1.18 1.18 0 0 1 0-.12 1.22 1.22 0 0 1 0-.12 1.16 1.16 0 0 1 0-.12 1.2 1.2 0 0 1 0-.13L0 12z"
          ></path>
        </svg>
      </div>
    );
  };
  const NextBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#3D3D3D"
            fillRule="evenodd"
            d="M32 12a1.22 1.22 0 0 0 0-.13v-.11a1.25 1.25 0 0 0 0-.13l-.05-.1-.07-.12-.07-.09-.08-.1L21 .39a1.3 1.3 0 0 0-1.82 0 1.25 1.25 0 0 0 0 1.79l8.43 8.56H1.29a1.3 1.3 0 0 0 0 2.59h26.42l-8.55 8.55a1.25 1.25 0 0 0 0 1.79 1.3 1.3 0 0 0 1.82 0L31.63 13l.08-.09.08-.09.06-.11.06-.11a1.18 1.18 0 0 0 0-.12 1.22 1.22 0 0 0 0-.12 1.16 1.16 0 0 0 0-.12 1.2 1.2 0 0 0 0-.13L32 12z"
          ></path>
        </svg>
      </div>
    );
  };
  //slider setting props
  const settings = {
    rows: 2,
    slidesPerRow: 2,
    dots: false,
    speed: 900,
    initialSlide: 1,
    slidesToScroll: 1,
    className: "slider variable-width",
    variableWidth: true,
    nextArrow: <NextBtn />,
    prevArrow: <PreviousBtn />,
    responsive: [
      {
        breakpoint: 1270,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          dots: true,
        },
      },
    ],
  };

  // redux dispatch func to fetch data from middleware asyncthunk
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getChooseSimForm());
  }, [dispatch]);
  const { loading, dataChoose } = useAppSelector((state) => state.chooseSlice);
  return (
    <section id="chooseSimform" style={{ backgroundColor: "#FBFBFE" }}>
      <Container
        maxWidth="lg"
        sx={{
          padding: { xs: "50px 0 75px", sm: "50px 0", md: "20px 0 130px" },
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h3"
                gutterBottom
                sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
              >
                Why Organizations{" "}
                <span className="highlight-head">Choose Simform</span>
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  textAlign: { xs: "center", sm: "center", md: "left" },
                  mb: 3.7,
                  lineHeight: 1.55,
                  letterSpacing: "-0.14px",
                }}
              >
                Discover the many ways in which our clients have embraced the
                benefits of Simform way of engineering.
              </Typography>
              {loading && (
                <Grid item xs={12} md={12}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Box className="chooseSimFormWrapper">
            <Slider {...settings}>
              {dataChoose != null &&
                dataChoose.length > 0 &&
                dataChoose.map((data, i) => (
                  <div data-index={i} key={i} className="sliderWrapper">
                    <Box
                      className="simFormSlider"
                      sx={{
                        textDecoration: "none",
                        color: "rgb(61, 61, 61)",
                        background: backGroundColorMultiples(i),
                        padding: "20px",
                        minHeight: "460px",
                        transition: "all 0.5s ease 0s",
                        borderRadius: "12px",
                        width: { xs: "100%", sm: "100%", md: "96%" },
                        marginBottom: "25px",
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                    >
                      <Box className="sliderItems">
                        <img
                          src={data.img}
                          width="100px"
                          height="30px"
                          style={{ marginBottom: "20px" }}
                          alt="logo"
                        />
                        <Typography
                          variant="h6"
                          gutterBottom
                          sx={{ fontSize: "1.438rem" }}
                        >
                          {data.title.slice(0, 20)}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          component="p"
                          gutterBottom
                          align="left"
                          sx={{ fontSize: "1rem" }}
                        >
                          {data.description.slice(0, 90)}
                        </Typography>
                        <Link
                          href="#"
                          sx={{
                            fontFamily: "GraphikRegular",
                            fontSize: "18px",
                            lineHeight: "24px",
                            marginTop: "23px",
                            fontWeight: "500",
                            position: "relative",
                            color: "rgb(239, 83, 102)",
                            transition: "all 0.5s ease 0s",
                            display: "inline-block",
                            textDecoration: "none",
                            marginBottom: "19px",
                          }}
                          className="btn-read"
                        >
                          <span className="line"></span>
                          Learn more
                        </Link>
                        <Box>
                          <Typography
                            variant="h5"
                            gutterBottom
                            sx={{
                              fontSize: "1rem",
                              borderBottom: "1px solid rgb(61, 61, 61)",
                            }}
                          >
                            Results
                          </Typography>
                          <Grid container spacing={4}>
                            <Grid item>
                              <div className="case-result-col">
                                <h5>$125 Million</h5>
                                <p>Funding for Next Gen development</p>
                              </div>
                            </Grid>
                            <Grid item>
                              <div className="case-result-col">
                                <h5>Used by big companies</h5>
                                <p>
                                  Walmart, Uber, Volvo, Linkedin, BellEnergy
                                </p>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    </Box>
                  </div>
                ))}
            </Slider>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default ChooseSimform;
